import http from '../../core/services/http'

export const generateMenusNotMatchingNormalizationRegexReport = platformId =>
  http.get(`/reports/menus-not-matching-normalization-regex/${platformId}`, {
    responseType: 'blob',
  })
